import {
  ExponentialBackoff,
  ExponentialBackoffOptions,
  INITIAL_WAIT_TIME_MS,
  MAX_RETRIES,
} from './ExponentialBackoff';

type ErrorType = {
  response?: { status: number };
  code?: string;
  message: string;
};

const CONFIG_429: ExponentialBackoffOptions<ErrorType> = {
  doRetry: (error) => {
    const { response, code, message } = error;
    const isTimeout = code === 'ECONNABORTED' || message.includes('timeout');
    const isRateLimit = !response || response.status === 429;
    return isRateLimit || isTimeout;
  },
  maxRetries: MAX_RETRIES,
  initialWaitTimeMs: INITIAL_WAIT_TIME_MS,
} as const;

export const withExponentialBackoff429 = new ExponentialBackoff(
  CONFIG_429,
).withExponentialBackoff();
